// Shared by the gifting deadline picker and the server's default expiry resolver.
const DEFAULT_GIFTING_REQUEST_EXPIRY_DAYS = 90;

module.exports = { DEFAULT_GIFTING_REQUEST_EXPIRY_DAYS };
